import React, { useContext, useEffect, useState } from 'react'
import {
  MenuItem,
  FormHelperText,
  FormControl,
  Select,
  Button,
  Box,
  CircularProgress,
} from '@mui/material'
import { useSnackbar } from 'notistack'
import { usePatchReviewStaffBenefitClaim } from '../../api/staff-benefit-claim'
import { ClaimReviewContext } from './ClaimReviewTable'
import {
  PENDING_STATUS,
  APPROVED_STATUS,
  DECLINED_STATUS,
} from '../../constant/staff-benefit-status'

export default function ClaimReviewSelect(props) {
  const { row } = props
  const { refetch } = useContext(ClaimReviewContext)
  const [status, setStatus] = useState(row.status)

  const { enqueueSnackbar } = useSnackbar()

  const { mutateAsync, isLoading } = usePatchReviewStaffBenefitClaim()

  const handleChange = (event) => {
    setStatus(event.target.value)
  }

  useEffect(() => {
    setStatus(row.status)
  }, [row])

  const handleUpdate = async () => {
    const res = await mutateAsync({ staffBenefitClaimId: row.id, status }).catch((e) => {
      if (e?.response?.data?.errors) {
        enqueueSnackbar(e?.response?.data?.errors[0]?.msg, {
          variant: 'error',
        })
      } else {
        enqueueSnackbar(e?.response?.data?.message ?? 'Fail to update', {
          variant: 'error',
        })
      }
      refetch()
    })
    if (res?.status === 200) {
      enqueueSnackbar(`Claim for ${row.user.name} is now ${status}`, {
        variant: 'success',
      })
      refetch()
    }
  }

  return (
    <Box display='flex' flexDirection='row'>
      <FormControl>
        <Select
          value={status}
          onChange={handleChange}
          displayEmpty
          inputProps={{ 'aria-label': 'Without label' }}
          size='small'
        >
          <MenuItem value={PENDING_STATUS}>{PENDING_STATUS}</MenuItem>
          <MenuItem value={APPROVED_STATUS}>{APPROVED_STATUS}</MenuItem>
          <MenuItem value={DECLINED_STATUS}>{DECLINED_STATUS}</MenuItem>
        </Select>
        <FormHelperText>Update the status</FormHelperText>
      </FormControl>
      <Box ml={3}>
        <Button
          variant='contained'
          style={{ maxHeight: '30px' }}
          onClick={handleUpdate}
          disabled={status === row.status || isLoading}
        >
          {isLoading && <CircularProgress size='1rem' />}
          Update
        </Button>
      </Box>
    </Box>
  )
}
